import * as Yup from 'yup';
import { phoneExpression } from './expressions';
import { AllValidations } from './validation.types';

Yup.addMethod(Yup.string, 'isBetween', function(min, max, message) {
  return this.test({
    name: 'isBetween',
    message: message,
    test: value => {
      if (value) {
        const enteredValue = value.substring(1);
        const float = parseFloat(enteredValue);
        if (float >= min && float <= max) {
          return true;
        }
        return false;
      }
      return true;
    }
  });
});

export const getValidationRules = (data: any) => {
  const allValidations: AllValidations = {};

  Object.entries(data.fields).forEach(([key, field]: any) => {
    if (field.validations) {
      switch (field.validator) {
        case 'required':
          allValidations[key] = Yup.string().required(field.validations.required.message);
          break;

        case 'requiredPostcodeAU':
          allValidations[key] = Yup.string()
            .min(4, field.validations.minCharacter.message)
            .required(field.validations.required.message);
          break;

        case 'hiddenPostcode':
          allValidations[key] = Yup.mixed().notOneOf(
            field.validations.inValidOption.options,
            field.validations.inValidOption.message
          );
          break;

        case 'requiredOptionSet':
          allValidations[key] = Yup.mixed()
            .required(field.validations.required.message)
            .oneOf(field.validations.validOption.options, field.validations.validOption.message);
          break;

        case 'requiredEmail':
          allValidations[key] = Yup.string()
            .required(field.validations.required.message)
            .email(field.validations.email.message);
          break;

        case 'email':
          allValidations[key] = Yup.string().email(field.validations.email.message);
          break;

        case 'requiredPhoneNo':
          allValidations[key] = Yup.string()
            .min(10, field.validations.minCharacter.message)
            .matches(phoneExpression, field.validations.phoneNo.message)
            .required(field.validations.required.message);
          break;

        case 'phoneNo':
          allValidations[key] = Yup.string()
            .min(10, field.validations.minCharacter.message)
            .matches(phoneExpression, field.validations.phoneNo.message);
          break;

        case 'requiredWithinRange':
          allValidations[key] = Yup.string()
            //@ts-ignore
            .isBetween(100, 10000, field.validations.range.message)
            .required(field.validations.required.message);
          break;
      }
    }
  });

  return allValidations;
};
